import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

function HowToUsePage() {
  const { t } = useTranslation('landing');

  const sections = [
    { id: 'getting-started', icon: '🚀', accent: 'primary', title: t('guide.gettingStartedTitle'), body: t('guide.gettingStartedBody') },
    { id: 'dashboard', icon: '📊', accent: 'info', title: t('guide.dashboardTitle'), body: t('guide.dashboardBody') },
    {
      id: 'expenses',
      icon: '💰',
      accent: 'success',
      title: t('guide.expensesTitle'),
      body: t('guide.expensesBody'),
      list: [t('guide.expensesItem1'), t('guide.expensesItem2'), t('guide.expensesItem3'), t('guide.expensesItem4')],
    },
    { id: 'goals', icon: '🎯', accent: 'secondary', title: t('guide.goalsTitle'), body: t('guide.goalsBody') },
    { id: 'checklist', icon: '✅', accent: 'warning', title: t('guide.checklistTitle'), body: t('guide.checklistBody') },
    { id: 'settings', icon: '⚙️', accent: 'indigo', title: t('guide.settingsTitle'), body: t('guide.settingsBody') },
    { id: 'help', icon: '💬', accent: 'orchid', title: t('guide.helpTitle'), body: t('guide.helpBody') },
  ];

  return (
    <div className="how-to-use-page">
      <Helmet>
        <title>How to Use Zlux - Guide</title>
        <meta name="description" content="A quick walkthrough of everything Zlux can do: getting started, your dashboard, expense tracking, goal planning, and daily checklists." />
        <link rel="canonical" href="https://zlux.asia/how-to-use" />
      </Helmet>
      <header className="how-to-hero">
        <p className="eyebrow">{t('guide.eyebrow')}</p>
        <h1 className="how-to-title">{t('guide.title')}</h1>
        <p className="how-to-hero-body">{t('guide.subtitle')}</p>
      </header>

      <nav className="how-to-toc" aria-label="Jump to section">
        {sections.map((section) => (
          <a key={section.id} href={`#${section.id}`} className="how-to-toc-link">
            <span aria-hidden="true">{section.icon}</span> {section.title}
          </a>
        ))}
      </nav>

      <div className="how-to-sections">
        {sections.map((section) => (
          <section
            key={section.id}
            id={section.id}
            className="card how-to-section"
            style={{ '--accent': `var(--${section.accent}-color)` }}
          >
            <div className="how-to-section-header">
              <span className="how-to-section-icon" aria-hidden="true">{section.icon}</span>
              <h2>{section.title}</h2>
            </div>
            <p>{section.body}</p>
            {section.list && (
              <ul>
                {section.list.map((item) => <li key={item}>{item}</li>)}
              </ul>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}

export default HowToUsePage;
